interface WebVitalMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
  id: string;
}

const RATING_COLORS: Record<string, string> = {
  good: '#0cce6b',
  'needs-improvement': '#ffa400',
  poor: '#ff4e42',
};

function logToConsole({ name, value, rating }: WebVitalMetric) {
  const color = RATING_COLORS[rating] || '#888';
  console.log(
    `%c[Web Vitals] ${name}: ${Math.round(name === 'CLS' ? value * 1000 : value)}${name === 'CLS' ? '' : 'ms'} (${rating})`,
    `color: ${color}; font-weight: bold;`
  );
}

function sendToEndpoint({ name, value, rating, id }: WebVitalMetric) {
  const endpoint = process.env.REACT_APP_VITALS_ENDPOINT;
  if (!endpoint) return;

  const body = JSON.stringify({ name, value, rating, id });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(endpoint, body);
  }
}

export function reportWebVitals() {
  import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
    const handler = process.env.NODE_ENV === 'development' ? logToConsole : sendToEndpoint;

    onCLS(handler);
    onINP(handler);
    onFCP(handler);
    onLCP(handler);
    onTTFB(handler);
  });
}
